import { render, staticRenderFns } from "./VisitorsPurplePhoneContacts.vue?vue&type=template&id=d8f48498&"
import script from "./VisitorsPurplePhoneContacts.vue?vue&type=script&lang=js&"
export * from "./VisitorsPurplePhoneContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports